'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const BlockSalesChart = dynamic(() => import('./BlockSalesChart'), { ssr: false });
const CategoryChart = dynamic(() => import('./CategoryChart'), { ssr: false });

export default function AdminChartsRow() {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
      <div className="xl:col-span-2 cosmic-card rounded-xl p-6 border border-border">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h3 className="font-display text-base font-semibold text-foreground">Daily Block Sales</h3>
            <p className="text-xs text-muted-foreground mt-0.5">Last 30 days — blocks claimed per day</p>
          </div>
          <div className="flex items-center gap-2 px-3 py-1 rounded-lg bg-primary/10 border border-primary/20">
            <span className="text-xs text-primary font-medium">+12,847 today</span>
          </div>
        </div>
        <BlockSalesChart />
      </div>
      <div className="cosmic-card rounded-xl p-6 border border-border">
        <div className="mb-6">
          <h3 className="font-display text-base font-semibold text-foreground">Sales by Category</h3>
          <p className="text-xs text-muted-foreground mt-0.5">All-time distribution</p>
        </div>
        <CategoryChart />
      </div>
    </div>
  );
}